class ProductRelated extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.item.elements?.forEach(itemEl => this.listeners.add(itemEl, 'mouseover', this.handleMouseOver.bind(this)))
    this.els.item.elements?.forEach(itemEl => this.listeners.add(itemEl, 'mouseleave', this.handleMouseLeave.bind(this)))
  }

  handleMouseOver(event) {
    const itemEl = event.target.closest(this.els.item.selector)
    const titleEl = this.querySelector(
      `.prd-ProductRelated_Text`,
    )
    const itemFirstEl = this.querySelector(
      `.prd-ProductRelated_Item-first`,
    )

    if(!itemEl) return

    titleEl.innerHTML = `${itemEl.dataset.label}`
    itemFirstEl.classList.remove('prd-ProductRelated_Item-border')
  }

  handleMouseLeave(event) {
    const itemEl = event.target.closest(this.els.item.selector)
    const titleEl = this.querySelector(
      `.prd-ProductRelated_Text`,
    )
    const itemFirstEl = this.querySelector(
      `.prd-ProductRelated_Item-first`,
    )

    if(!itemEl) return

    titleEl.innerHTML = `${itemFirstEl.dataset.label}`
    itemFirstEl.classList.add('prd-ProductRelated_Item-border')
  }
}

if (!customElements.get('product-related')) {
  customElements.define('product-related', ProductRelated)
}
